<template>
  <div
    class="propaganda-bg"
    :style="{ backgroundColor: type == 4 ? '#0522a5' : '' }"
  >
    <div v-if="showLoading" class="loading-container">
      <loading color="#1989fa" />
    </div>
    <div class="marquee" v-if="marqueeData.length > 0">
      <marquee :duration="marqueeData.length * 3" :repeat="30">
        <template v-for="(item, index) in marqueeData">
          <div :key="index" class="marquee-item">
            <img
              v-if="item.company_horse_logo"
              :src="item.company_horse_logo"
              alt
            />
            <span v-if="item.company_horse_name">{{
              item.company_horse_name
            }}</span>
          </div>
        </template>
      </marquee>
    </div>
    <div
      class="posters"
      @click="clickShare"
      v-show="detail.poster_share_status == 1 && showPosterButton"
    >
      <img class="posters-img" src="@assets/images/posters.png" alt />
    </div>

    <div class="zh_en" @click="changeZhEn" v-if="language_url">
      <img src="@images/en_zh.svg" alt="" />
    </div>
    <poster
      ref="share"
      :shareData="shareData"
      :left="left"
      v-if="showPoster"
      @close="showPoster = false"
    ></poster>
    <carousel
      :isShowBack="isShowBack"
      :data="adsData"
      @item-click="carouselClick"
      class="carouselHeight"
    />
    <div class="ad-image" v-if="detail.propaganda_ads">
      <img :src="detail.propaganda_ads" alt />
      <img
        v-if="isShowBack"
        @click="$router.go(-1)"
        class="back"
        src="@assets/images/home-back.png"
        alt=""
      />
    </div>
    <div
      class="content item-content"
      :style="{
        backgroundImage: detail.propaganda_backgroud_img
          ? `url(${detail.propaganda_backgroud_img})`
          : '',
        backgroundColor: type == 354 ? '#e6f2f6 ' : '',
      }"
    >
      <!-- <template v-if="type != 354"> -->
      <div
        :class="[
          'countdown-container',
          type == 4 ? 'countdown-container-d' : 'countdown-container-b',
        ]"
        :style="{ top: type != 4 ? carouselTop : '' }"
        v-show="showCountdown"
      >
        <!-- 没找到原因为啥不能注释，注释倒计时样式就有问题 -->
        <img
          class="countdown-img"
          src="@images/countdown_text.png"
          v-show="false"
        />
        <span class="countdown-text">大会倒计时：</span>
        <div class="countdown"></div>
      </div>
      <!-- </template> -->
       
      <template-a :data="propagandaList" v-if="type == 1"></template-a>
      <template-b :data="propagandaList" v-else-if="type == 2"></template-b>
      <template-c :data="propagandaList" v-else-if="type == 3"></template-c>
      
      <template-d
        :data="propagandaList"
        v-else-if="type == 4"
        :notice="detail.propaganda_notice"
      ></template-d>
      <template-138
        :data="propagandaList"
        v-else-if="type == 138"
      ></template-138>
      <template354
        :data="propagandaList"
        :serveTime="serveTime"
        :subjectTime="subjectTime"
        v-else-if="type == 354"
      ></template354>
      <template360 :data="propagandaList" v-else-if="type == 360"></template360>
      <!-- <template366
                :data="propagandaList"
                :serveTime="serveTime"
                :subjectTime="subjectTime"
                v-else-if="type == 366"
            ></template366> -->
    </div>
    <div
      class="bottom"
      v-show="detail.propaganda_foot_banner"
      @click="gotoBottomLink"
    >
      <img class="bottom-img" :src="detail.propaganda_foot_banner" alt />
    </div>
    <div
      class="mark_outer"
      id="play_mark_outer"
      v-if="videoShow"
      :style="{ width: isPcWidth, left: left }"
    >
      <img
        style="z-index: 1"
        class="video_close"
        src="../../assets/images/week_close.png"
        alt
        @click="videoClose"
      />
      <div id="video_wrap" style="width: 100%">
        <video
          id="player"
          style="width: 100%"
          controlslist="nodownload"
          controls
          :src="videoUrl"
          :poster="videoCover"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import Marquee from '@components/Marquee'
import Carousel from '@components/Carousel'
import TemplateA from './components/template/TemplateA'
import TemplateB from './components/template/TemplateB'
import TemplateC from './components/template/TemplateC'
import TemplateD from './components/template/TemplateD'
import Template138 from './components/template/Template138'
import Template354 from './components/template/Template354'
import Template360 from './components/template/Template360'
import Template366 from './components/template/Template366'
import Poster from './components/Poster'
import os from '@utils/os'
import { getSharePoster, getAds, getDetail, getEnterprise, getWxShare } from './request'
import ImgLoadListener from '@utils/imageLoadListener'
import { Loading } from 'vant'

export default {
  components: {
    TemplateA,
    TemplateB,
    TemplateC,
    TemplateD,
    Template138,
    Template354,
    Template360,
    Template366,
    Poster,
    Marquee,
    Carousel,
    Loading
  },
  data () {
    return {
      detail: {},
      marqueeData: [],
      adsData: [],
      showCountdown: false,
      shareData: {},
      showPoster: false,
      left: '',
      propagandaList: [],
      type: 1,
      videoShow: false,
      videoUrl: '',
      videoCover: '',
      carouselTop: '',
      title: '',
      desc: '',
      imgUrl: '',
      linkr: '',
      showPosterButton: false,
      showLoading: true,
      language_url: '',
      wxShareImage: '',
      serveTime: '',
      subjectTime: ''
    }
  },
  created () {
    this.getAds()
    this.getDetail()

    window.addEventListener('hashchange', val => {
      const { newURL, oldURL } = val
      if (newURL != oldURL) location.reload()
    })
  },
  computed: {
    isPcWidth () {
      if (os.isPC()) return '580px'
      return '100%'
    },
    isShowBack () {
      if (window.sessionStorage.firstUrl === window.location.href) {
        return false
      } else {
        return true
      }
    }
  },
  mounted () {
    this.$nextTick(_ => {
      document.querySelector('.posters').style.left =
        document.querySelector('.propaganda-bg').getBoundingClientRect().width +
        document.querySelector('.propaganda-bg').getBoundingClientRect().left -
        parseFloat(document.querySelector('html').style.fontSize) * 3 +
        'px'
      // zh_en
    })
    this.left = document.querySelector('.propaganda-bg').getBoundingClientRect().left + 'px'
    this.top = console.log(this.left, 'this.left------')
  },
  methods: {
    getWxShare () {
      getWxShare({
        url: location.href
      }).then(res => {
        // // let _this = this
        // var wxchat = res
        this.$wx.config(res)
        setTimeout(() => {
          // console.log(this.desc)
          let imgUrl = ''
          if (this.$route.query.id == '322') {
            imgUrl =
              'https://file.docbook.com.cn/upload/images/1d/82/42/1d8242c4431612b69e7b08958392cfb4.jpg?x-oss-process=image/resize,w_200'
          } else if (this.$route.query.id == '323') {
            imgUrl =
              'http://file.docbook.com.cn/upload/images/75/3b/b5/753bb5465178b513f6b7c277454becc8.jpg?x-oss-process=image/resize,w_200'
          } else if (this.$route.query.id == '324') {
            imgUrl =
              'https://file.docbook.com.cn/upload/images/41/37/b8/4137b8fe7166721d113ad691e3ead02a.jpg?x-oss-process=image/resize,w_200'
          } else if (this.$route.query.id == '326') {
            imgUrl =
              'http://file.docbook.com.cn/upload/images/99/ac/4b/99ac4ba244c5dcfa6aa5e99e3b84dc18.jpg?x-oss-process=image/resize,w_200'
          } else {
            imgUrl = this.imgUrl
          }
          this.$wx.share({
            title: this.title,
            desc: this.desc,
            imgUrl: this.detail.share_image
              ? this.detail.share_image + '?x-oss-process=image/resize,w_200'
              : imgUrl,
            link: this.linkr
          })
        }, 500)
      })
    },
    changeZhEn () {
      //   window.location.href = this.language_url
      window.go(this.language_url)
    },
    getDetail () {
      this.showLoading = true
      getDetail({
        propaganda_id: this.$route.query.id
      }).then(res => {
        const { data } = res
        this.detail = data

        const {
          subject_id,
          propaganda_title,
          server_time,
          subject_time,
          meeting_id,
          propaganda_list,
          template_type,
          propaganda_cover,
          subject_date,
          language_url
        } = data
        document.title = propaganda_title
        this.propagandaList = propaganda_list
        let type = this.$route.query.t || template_type

        this.serveTime = server_time
        this.subjectTime = subject_time

        if (this.$route.query.id == 138) type = 138 // 处理138
        if (this.$route.query.id == 354) type = 354 // 处理354
        if (this.$route.query.id == 360) type = 360 // 处理360
        // if (this.$route.query.id == 366) type = 366 // 处理366
        this.title = propaganda_title
        this.imgUrl = propaganda_cover
        this.language_url = language_url
        if (subject_date) {
          this.desc = '会议时间:\n' + subject_date + '\n' + data.wechat_share_content
        } else {
          this.desc = data.wechat_share_content
        }

        this.linkr = location.href
        this.getSharePoster(meeting_id)
        // this.$set(data, 'wechat_share_status', '2')
        if (data.wechat_share_status == 2) this.$wx.hideMenu()
        this.getWxShare()
        this.$nextTick(async () => {
          this.type = type

          await this.createMarquee(subject_id)

          this.$nextTick(() => {
            if (type != '354') {
              this.showCountdown = true
            }

            setTimeout(() => {
              if (type != '354') {
                this.createCountdown(server_time, subject_time)
              }
              if (this.type != 4) {
                const rem = $('html').css('fontSize').replace('px', '')

                let marqueeHeight = this.marqueeData.length > 0 ? 1.55 : 0

                this.carouselTop =
                  (marqueeHeight + 7) * rem + (os.isPC() ? 14.375 : 0) + 'px'
              }


              const contentNode = document.querySelector('.item-content')
              if (contentNode && type != 4) {
                setTimeout(() => {

                  requestAnimationFrame(() => {
                    const rect = contentNode.getBoundingClientRect();
                    const marginTop = window.innerHeight - rect.top - (window.innerWidth * 168) / 750;
                    if (marginTop > rect.height)
                      contentNode.style.height = `${marginTop}px`;
                    console.log('innerHeight:', window.innerHeight, 'marginTop:', marginTop, 'top:', rect.top, 'height:', rect.height, 500)

                  });
                  //   加载图片速度太慢了，500应该没问题了
                }, 500)
              } else {
                console.log('footer not found')
              }
              setTimeout(() => {
                this.showLoading = false
              }, 200)
              if (this.language_url) {
                document.querySelector('.zh_en').style.left =
                  document.querySelector('.propaganda-bg').getBoundingClientRect()
                    .width +
                  document.querySelector('.propaganda-bg').getBoundingClientRect()
                    .left -
                  document.querySelector('.zh_en').getBoundingClientRect().width +
                  'px'
              }
            }, 0)
          })
        })
        // this.showLoading = false
      })
    },
    getSharePoster (meeting_id) {
      getSharePoster({
        meeting_id
      }).then(res => {
        console.log(res)
        if (res.status == 200) {
          this.shareData = res.data
          this.showPosterButton = true
        }
      })
    },
    getAds () {
      getAds({
        propaganda_id: this.$route.query.id
      }).then(res => {
        this.adsData = res.data.map(item => {
          return {
            ...item,
            cover_url: item.cover_url + '?x-oss-process=image/resize,w_750'
          }
        })
      })
    },
    async createMarquee (subject_id) {
      return new Promise((resolve, reject) => {
        getEnterprise({
          subject_id,
          display_platform: 1
        })
          .then(res => {
            this.marqueeData = res.data
            resolve(res.data)
          })
          .catch(e => reject(e))
      })
    },
    // 分享海报
    clickShare () {
      window.scrollTo(0, 0)
      this.showPoster = true
      // this.$refs.share.add_listener()
    },
    createCountdown (start, end) {
      let b = new Date()
      b = -b.getTimezoneOffset() / 60
      var config = {
        currentTime: start * 1000,
        timeText: end, //倒计时时间
        timeZone: b, //时区
        style: 'flip', //显示的样式，可选值有flip,slide,metal,crystal
        color: 'black', //显示的颜色，可选值white,black
        width: $('.countdown-img').width(), //倒计时宽度
        textGroupSpace: 0, //天、时、分、秒之间间距
        textSpace: 0, //数字之间间距
        reflection: false, //是否显示倒影
        dayTextNumber: 2, //倒计时天数数字个数
        displayDay: true, //是否显示天数
        displayHour: true, //是否显示小时数
        displayMinute: true, //是否显示分钟数
        displaySecond: true, //是否显示秒数
        displayLabel: false, //是否显示倒计时底部label
        onFinish: () => {
          this.showCountdown = false
        }
      }
      $('.countdown').jCountdown(config)
    },
    carouselClick (item) {
      const { ads_link, type } = item
      if (type == 1) {
        // location.href = ads_link
        if (ads_link) window.go(ads_link)
      } else {
        this.videoShow = true
        this.videoUrl = item.video_url
        this.videoCover = item.cover_url
        document.body.style.overflow = 'hidden'
      }
    },
    videoClose () {
      this.videoShow = false
      this.videoUrl = ''
      this.videoCover = ''
      document.body.style.overflow = 'auto'
    },
    gotoBottomLink () {
      // console.log('this.detail.foot_banner_url',this.detail.foot_banner_url)
      if (this.detail.foot_banner_url) {
        if (this.detail.foot_banner_url.indexOf('https://mp.weixin.qq.com') == -1) {
          //   location.href = this.detail.foot_banner_url
          window.go(this.detail.foot_banner_url)
        } else {
          if (os.isWechat() == 1 || os.isWechat() == 2) {
            // location.href = this.detail.foot_banner_url
            window.go(this.detail.foot_banner_url)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.propaganda-bg {
  width: 100%;
  display: flex;
  flex-direction: column;
  // flex: 1;
  // height: 0;
}

.loading-container {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  z-index: 9;
}

.enterprise-lamp {
  padding-top: 0.25rem;
  width: 100%;
  height: 1.65rem;
  background: white;
  overflow: hidden;
}

.marquee {
  width: 100%;
  background: #fff;

  .marquee-item {
    padding: 0.1rem 0.2rem;
    margin-left: 0.3rem;
    display: flex;
    align-items: center;

    > span {
      margin-left: 0.2rem;
      font-size: 0.55rem;
      color: #06225a;
    }

    > img {
      width: 1.28rem;
      height: 1.28rem;
      border-radius: 100%;
      border: 0.35rem;
      border: solid 1px #e7efff;
    }
  }
}
.posters {
  position: fixed;
  bottom: 3.65rem;
  right: 0.43rem;
  cursor: pointer;
  z-index: 1;
  .posters-img {
    width: 2.5rem;
    height: 2.5rem;
  }
}
.zh_en {
  position: fixed;
  right: 0;
  top: 21.3%;
  z-index: 1;
  img {
    width: 1.39rem;
    height: 1.23rem;
  }
}
.ad-image {
  width: 100%;
  // height: 19rem;
  overflow: hidden;
  position: relative;
  .back {
    position: absolute;
    top: 0.2rem;
    left: 0.43rem;
    width: 1rem;
    height: 1rem;
  }
}
.ad-image img {
  width: 100%;
  height: 100%;
}
.content {
  padding-top: 0.2rem;
  // background: url() no-repeat center center;
  background-size: 100% 100%;
  // flex: 1;
  // overflow: auto;

  .countdown-container {
    margin-top: 0.1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .countdown-img {
      width: 7rem;
    }

    .countdown {
      margin-top: 0.2rem;
      // height: 1.35rem;
      position: relative;
    }
    .countdown-b {
      margin-top: 0.2rem;
      // height: 1.35rem;
      position: relative;
    }
  }
}
.countdown-container-b {
  height: 2rem;

  width: 100%;
  display: flex;
  // flex-direction: column;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  position: absolute !important;
  top: 0;
  left: 0;
  font-size: 0.5rem;
  background: rgba(255, 255, 255, 0.68);
  margin-top: 0.1rem;

  .countdown-img {
    width: 7rem;
  }

  .countdown {
    margin-top: 0.2rem;
    // height: 1.35rem;
    position: relative;
  }
  .countdown-b {
    margin-top: 0.2rem;
    // height: 1.35rem;
    position: relative;
  }

  .countdown-text {
    position: relative;
    top: 2px;
  }
}

.countdown-container-d {
  position: relative;
  display: flex;
  top: 0 !important;
  font-size: 0.5rem;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;

  .countdown-img {
    width: 9rem !important;
  }

  .countdown-text {
    color: #ffffff;
  }

  ::v-deep .countdown_unit {
    color: #ffffff;
  }
}

.bottom {
  width: 100%;
  cursor: pointer;
  .bottom-img {
    width: 100%;
  }
}
.mark_outer {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: black;
  z-index: 13;
  display: flex;
  align-items: center;
  justify-content: center;
  // display: none;
}

.video_close {
  position: absolute;
  top: 1rem;
  left: 1rem;
  width: 2rem;
  height: 2rem;
}
</style>
